<template lang="pug">
  .HeaderButton
    .HeaderButton-button
      button.Btn.BtnIcon.BtnIcon--oval(
        @click='onClick',
        :class="{'Btn--blue': isActive, 'Btn--greyLighter': !isActive}")
        i.Icon(:class="icon")
    .HeaderButton-tooltip.Tooltip(:class="{'HeaderButton-tooltip--nolist': !list || list.length === 0}")
      .HeaderButton-title.OneLine {{title}}
      .HeaderButton-list.List(v-if="list && list.length > 0")
        .List-item.Item(v-for="item in list")
          .Item-left.OneLine {{item.left}}
          .Item-right.OneLine {{item.right}}

</template>

<script>
  export default {
    name: 'header-button',
    props: {
      icon: '',
      title: '',
      isActive: false,
      list: {
        type: Array,
        default: () => { return [] }
      }
    },
    methods: {
      onClick() {
        this.$emit('clicked')
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '~base';
  .HeaderButton {
    position: relative;
    margin-right: 6px;
    margin-bottom: 4px;

    .Btn {
      width: 50px;
    }

    &:hover .BtnIcon--oval {
      background: $blue;
      color: $white;

      .BtnHiddenPart {
        display: inline-block;
      }
    }

    &-tooltip {
      padding: 13px 20px 20px;

      &--nolist {
        padding: 5px 10px;
      }
    }

    &:hover &-tooltip {
      display: block;
    }
  }

  .Item {
    display: flex;
    padding: 7px 0;
    justify-content: space-between;

    &-right {
      margin-left: 10px;
    }
  }

  .IconPanelLayers,
  .IconPanelTable,
  .IconPanelChart {
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/HeaderButton.vue